import { styled } from '@linaria/react';
import { Badge } from '../../components/Badge';
import { fonts, layout, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Container = styled.div`
  width: 100%;
`;

export const Columns = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$columns}, minmax(0, 1fr));
  gap: ${space['space-800']};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Header = styled.div`
  margin-bottom: ${space['space-400']};
`;

export const StaticHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  padding: ${layout.inputPadding};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('card', 'radius-md')};
  background: ${semantic.bg.canvas};
`;

export const Stay = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  margin-top: ${space['space-200']};
  padding-bottom: ${space['space-400']};
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
`;

export const StayLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const StayName = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};

  [data-text-size='small'] & {
    font-size: ${fonts.size.sm};
  }
`;

export const HeaderLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.tertiary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const HeaderName = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const TriggerValue = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  white-space: normal;
  text-align: left;
`;

export const DateGroup = styled.div`
  display: grid;
  grid-template-columns: minmax(${space['space-2400']}, auto) 1fr;
  align-items: baseline;
  gap: ${space['space-600']};
  padding-top: ${space['space-400']};

  &[data-single='true'] {
    display: block;
  }
`;

export const DateLabel = styled.h4`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};

  [data-single='true'] > & {
    margin-bottom: ${space['space-200']};
  }

  [data-text-size='small'] & {
    font-size: ${fonts.size.sm};
  }
`;

export const Activities = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ActivityRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${space['space-600']};
  padding: ${space['space-400']} 0;
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};

  > *:first-child {
    flex-shrink: 0;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TimePlaceholder = styled.span`
  display: inline-flex;
  min-width: ${space['space-1600']};
  padding: ${space['space-100']} 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  border-radius: ${radius('chip', 'radius-full')};

  &[data-pending='true'] {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const TimeBadge = styled(Badge)`
  box-sizing: border-box;
  min-width: ${space['space-1600']};
`;

export const ActivityText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  min-width: 0;
`;

export const ActivityTitle = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};

  &[data-pending='true'] {
    color: ${semantic.text.secondary};
  }

  [data-text-size='small'] & {
    font-size: ${fonts.size.sm};
  }
`;

export const ActivityLocation = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;
